module.exports = __webpack_public_path__ + "static/media/Rec1.1016fcd4.png";